import React from "react";

// Fixed low-opacity SVG fractal noise overlay for cinematic grain.
export const NoiseOverlay = () => (
  <div className="noise-overlay" aria-hidden="true">
    <svg width="100%" height="100%">
      <filter id="inove-noise">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.8"
          numOctaves="3"
          stitchTiles="stitch"
        />
      </filter>
      <rect width="100%" height="100%" filter="url(#inove-noise)" />
    </svg>
  </div>
);
